import { render, staticRenderFns } from "./jxfw.vue?vue&type=template&id=ddaf6a2e&scoped=true"
import script from "./jxfw.vue?vue&type=script&lang=js"
export * from "./jxfw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaf6a2e",
  null
  
)

export default component.exports